module.exports = __webpack_public_path__ + "img/flag-DENMARK.903944f9.svg";